import 'iconify-icon';
import {ApplicationRef, enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {appConfig} from './app.config';
import {environment} from '../environments/environment';
import {removeBootPreloader} from './core/boot/boot-preloader';

// Zapnutí produkčního módu
if (environment.production) {
    enableProdMode();
}

/**
 * Nastartuje aplikaci se sdílenou konfigurací.
 * Společné pro `src/main.ts` i `src/main.mock.ts`, aby mock vstup nemohl divergovat
 * v providerech — liší se jen tím, co udělá před bootstrapem (MSW worker) a po něm (toolbar).
 *
 * Boot preloader z `index.html` se tu po úspěchu NEsundává: s `enabledNonBlocking` bootstrap
 * skončí ještě před guardy první navigace. Drží ho `AppComponent` do prvního `NavigationEnd`
 * (viz `core/boot/boot-preloader.ts`). Při pádu bootstrapu ho sundáme, aby spinner neschoval
 * chybový stav.
 */
export function bootstrapApp(): Promise<ApplicationRef> {
    return bootstrapApplication(AppComponent, appConfig).catch(err => {
        removeBootPreloader();
        throw err;
    });
}
